export enum Status {
    Active = 1,
    InActive = 2,
    Deleted = 3
}

export  enum CreditControlEnum {
   On = 0 ,
   Off = 1,
   Hold =2
}

export enum CreditTypeEnum {
      IndividualCredit = 0,
      ConsolidatedCredit =1
 
}

export enum WorkflowUpdateRecordValueTypeEnum{
    Value = 1,
    Expresssion = 2,
}